import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

/**
 * Creates an Axios instance with an automatic request interceptor for mutating idempotency.
 * 
 * - For mutating HTTP methods (POST, PUT, PATCH, DELETE), if an 'Idempotency-Key'
 *   header is not already present, generates and attaches a new UUIDv4.
 * - If an 'Idempotency-Key' header is explicitly provided by the caller, it is preserved.
 * - For non-mutating methods (GET, HEAD, OPTIONS), 'Idempotency-Key' is never attached.
 *
 * @param {import('axios').CreateAxiosDefaults} [config]
 * @returns {import('axios').AxiosInstance}
 */
export function createApiClient(config) {
  var client = axios.create(config);
  client.interceptors.request.use(function (req) {
    var method = req.method ? req.method.toUpperCase() : 'GET';
    var mutatingMethods = ['POST', 'PUT', 'PATCH', 'DELETE'];
    if (mutatingMethods.includes(method)) {
      req.headers = req.headers || {};
      var existingKey = (typeof req.headers.get === 'function' ? req.headers.get('Idempotency-Key') : null) || req.headers['Idempotency-Key'] || req.headers['idempotency-key'];
      if (!existingKey) {
        var newKey = uuidv4();
        if (typeof req.headers.set === 'function') {
          req.headers.set('Idempotency-Key', newKey);
        }
        req.headers['Idempotency-Key'] = newKey;
      }
    }
    return req;
  });
  return client;
}
export default createApiClient;